import {
  getApplicationPhaseLabel,
  getApplicationTypeLabel,
  PHASE,
  RL_APPLICATION_TYPE,
} from "../../../config/phaseConstants";

interface NavbarApplicationInfoProps {
  applicationId?: string | number | null;
  status?: string | null;
  applicationType?: unknown; // raw rl_application_type
  currentPhase?: unknown; // raw current_phase
}

export function NavbarApplicationInfo({
  applicationId,
  status,
  applicationType,
  currentPhase,
}: NavbarApplicationInfoProps) {
  /**
   * A Tentative application in its Phase II continuation is the one being
   * converted to Permanent, so the navbar presents it as Permanent — label and
   * all, with no phase line, exactly like a true Permanent application.
   *
   * Display only: rl_application_type stays "Temporary" in the database, and
   * every piece of logic that reads it (phase-2 continuation, document filters,
   * validators) keeps seeing the raw values passed in here.
   */
  const isTentativeInPhase2 =
    applicationType === RL_APPLICATION_TYPE.TEMPORARY &&
    currentPhase === PHASE.PERMANENT_RL;

  /**
   * BEFORE — the label always followed the raw type, and the phase line hid
   * only for applications stored as Permanent:
   */
  // const typeLabel = getApplicationTypeLabel(applicationType);
  // const showPhase = applicationType !== RL_APPLICATION_TYPE.PERMANENT;

  const typeLabel = getApplicationTypeLabel(
    isTentativeInPhase2 ? RL_APPLICATION_TYPE.PERMANENT : applicationType
  );
  const phaseLabel = getApplicationPhaseLabel(currentPhase);
  /**
   * BEFORE - the phase line hid only for Permanent and Tentative-in-Phase-II:
   *
   * const showPhase =
   *   applicationType !== RL_APPLICATION_TYPE.PERMANENT && !isTentativeInPhase2;
   *
   * An Offline Tentative application has no phases either - it goes through
   * the Final Review chain once - so the line is hidden for it as well.
   */
  const showPhase =
    applicationType !== RL_APPLICATION_TYPE.PERMANENT &&
    applicationType !== RL_APPLICATION_TYPE.OFFLINE_TENTATIVE &&
    !isTentativeInPhase2;

  return (
    <div className="flex flex-col md:flex-row md:ml-auto md:mr-8 gap-y-1 md:gap-x-8">
      <div>
        <p className="text-grey-600">
          <span className="w-28 font-semibold inline-block">
            Application ID
          </span>
          <span className="text-grey-600 font-semibold mx-2">:</span>
          <span>{applicationId || "Nil"}</span>
        </p>
        <p className="text-grey-600 flex items-center">
          <span className="w-28 text-grey-600 font-semibold inline-block">
            Status
          </span>
          <span className="text-grey-600 font-semibold mx-2">:</span>
          <span className="text-primary">{status || "Nil"}</span>
        </p>
      </div>
      <div>
        <p className="text-grey-600">
          <span className="w-36 font-semibold inline-block">
            Application Type
          </span>
          <span className="text-grey-600 font-semibold mx-2">:</span>
          <span>{typeLabel}</span>
        </p>
        {showPhase && (
          <p className="text-grey-600 flex items-center">
            <span className="w-36 text-grey-600 font-semibold inline-block">
              Application Phase
            </span>
            <span className="text-grey-600 font-semibold mx-2">:</span>
            <span>{phaseLabel}</span>
          </p>
        )}
      </div>
    </div>
  );
}
